import { useMutation, useQueryClient } from '@tanstack/react-query';
import { request } from '@/utils/index';

const rateReport = async ({
  permalink,
  rate,
  comments,
}: {
  permalink: string;
  rate: string;
  comments?: string;
}) => {
  const url = `/api/v5/reports/${permalink}/report_rating`;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      'report_rating_survey_result[comment]': comments || '',
      'report_rating_survey_result[rating]': rate,
      'report_rating_survey_result[client]': 'web-desktop',
    }),
  };
  return await request(url, options);
};

export const useReportRating = (permalink: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: rateReport,
    onSuccess: () => {
      queryClient.invalidateQueries(['report', permalink]);
    },
  });
};
